import jwt from "jsonwebtoken";
import axios from "@/helpers/axios";
import router from "@/router/index.js";
import { resetUser } from "@/helpers/mixpanel";

const commonULR = "/users";

export default {
  namespaced: true,
  state: {
    accessToken: null, //auth
    refreshToken: null, //auth
  },
  actions: {
    async signin({ state, rootState, mutations, commit, getters }, payload) {
      try {
        const result = await axios({
          method: "post",
          url: `${commonULR}/biz/token`,
          data: payload,
          headers: {
            bypass: true,
          },
        });
        //다시보기
        return result.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    async refreshSignin(
      { getters, state, rootState, mutations, commit },
      payload
    ) {
      if (!state.refreshToken) {
        router.push(`/users/signin?router=${payload}`);
        throw Error("accessToken is empty");
      }

      try {
        const result = await axios({
          method: "post",
          url: `${commonULR}/biz/refresh-token`,
          data: {
            userId: getters["tokenPayload"]().userId,
            refreshToken: state.refreshToken,
          },
          headers: {
            bypass: true,
            refresh: true,
          },
        });
        if (!result.data.success) {
          router.push("/");
          commit("updateAccessToken", "");
          commit("updateRefreshToken", "");
          throw new Error("[refreshToken] Failed");
        }
        commit("updateAccessToken", result.data.accessToken);
        commit("updateRefreshToken", result.data.refreshToken);
        return true;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    async signout({ commit }) {
      commit("updateAccessToken", "");
      commit("updateRefreshToken", "");
      commit("replaceTemporaryOrders", [], { root: true });
      resetUser(); // 믹스패널 유저 정보 제거
    },
    updateAccessToken({ commit }, payload) {
      commit("updateAccessToken", payload);
    },
    updateRefreshToken({ commit }, payload) {
      commit("updateRefreshToken", payload);
    },
  },
  mutations: {
    updateAccessToken(state, payload) {
      state.accessToken = payload;
    },
    updateRefreshToken(state, payload) {
      state.refreshToken = payload;
    },
  },
  getters: {
    tokenPayload: (state, getters, rootState, rootGetters) => () => {
      try {
        const decoded = jwt.decode(state.accessToken);
        if (!decoded) return false;
        return decoded;
      } catch (e) {
        console.error(e);
        return false;
      }
    },
    isAuthenticated: (state, getters, rootState, rootGetters) => () => {
      const currentTime = Math.floor(new Date().getTime() / 1000) + 5;
      try {
        if (!state.accessToken) return false;
        const decoded = jwt.decode(state.accessToken);
        if (decoded.exp < currentTime) return false;
        return true;
      } catch (e) {
        console.error(e); // eslint-disable-line
        return false;
      }
    },
  },
};
